<template>
  <transition name="notify">
    <div v-if="visible" class="notification-wrapper">
      <div class="notification-card">
        <div class="header">
          <div class="header-left">
            <div class="icon">A</div>
            <div>
              <p class="title">{{ data.title || "Appointment Update" }}</p>
              <p class="subtitle">Appointment module notification</p>
            </div>
          </div>
          <button class="close" @click="close">×</button>
        </div>

        <div class="content">
          <p class="message">{{ data.message }}</p>
          <div v-if="data.details?.length" class="details">
            <div v-for="(detail, index) in data.details" :key="index" class="detail-line">{{ detail }}</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "AppointmentNotification",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      audio: null,
    };
  },
  mounted() {
    this.audio = new Audio("/sounds/notification.mp3");
    this.show();
  },
  methods: {
    show() {
      this.visible = true;
      this.audio?.play().catch(() => {});
      setTimeout(this.close, 12000);
    },
    close() {
      this.visible = false;
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.notification-wrapper { position: fixed; top: 24px; right: 24px; z-index: 9999; }
.notification-card { width: 360px; background: rgba(255, 255, 255, 0.94); backdrop-filter: blur(12px); border-radius: 18px; box-shadow: 0 20px 50px rgba(0, 0, 0, 0.18); overflow: hidden; }
.header { display: flex; justify-content: space-between; align-items: center; padding: 16px; background: #1e293b; color: #ffffff; }
.header-left { display: flex; gap: 12px; align-items: center; }
.icon { width: 38px; height: 38px; background: rgba(255, 255, 255, 0.16); border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 18px; font-weight: 700; }
.title { font-size: 14px; font-weight: 600; margin: 0; }
.subtitle { font-size: 11px; opacity: 0.85; }
.close { background: transparent; border: none; color: #ffffff; font-size: 18px; cursor: pointer; }
.content { padding: 16px; }
.message { margin: 0 0 10px; font-size: 13px; color: #111827; }
.details { display: grid; gap: 6px; }
.detail-line { font-size: 12px; color: #64748b; }
.notify-enter-active, .notify-leave-active { transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1); }
.notify-enter-from { opacity: 0; transform: translateX(120%) scale(0.95); }
.notify-leave-to { opacity: 0; transform: translateX(120%) scale(0.95); }
</style>
